import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { p as paddingMixin, m as mobilePaddingMixin } from '../theme/style-mixins/padding/index-BPYuRWh5.js';
import { C as CloseButton } from '../Button/CloseButton/CloseButton-cLZyFeIM.js';

const Shroud = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40027066__sc-un02xd-0"
})(["background-color:", ";backdrop-filter:blur(", ");position:fixed;top:0;right:0;bottom:0;left:0;overflow:hidden;display:flex;align-items:center;justify-content:center;z-index:", ";@media (prefers-reduced-motion:no-preference){transition:opacity ", "ms ease-in-out;}opacity:0;opacity:", ";"], ({
  theme
}) => theme.modal.shroudColor, ({
  theme
}) => theme.modal.shroudBlur, ({
  theme
}) => theme.elevation.zIndex.layer4, ({
  $fadeDuration
}) => $fadeDuration, ({
  $transitionState
}) => ({
  entering: 0,
  entered: 1,
  exiting: 0,
  exited: 0,
  unmounted: 0
})[$transitionState]);
Shroud.displayName = 'Shroud';
const OuterWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40027066__sc-un02xd-1"
})(["box-sizing:border-box;outline:none;width:fit-content;max-width:80%;overflow:hidden;box-shadow:", ";border-radius:", ";border:", ";@media (prefers-reduced-motion:no-preference){transition:all 100ms ease-in-out;}transform:", ";"], ({
  theme
}) => theme.elevation.shadow.modal, ({
  theme
}) => theme.border.radius.large, ({
  theme
}) => theme.border.subtle.default, ({
  $transitionState
}) => ({
  entering: 'scale(0.95)',
  entered: 'none',
  exiting: 'none',
  exited: 'none',
  unmounted: 'none'
})[$transitionState]);
OuterWrapper.displayName = 'OuterWrapper';
const Wrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40027066__sc-un02xd-2"
})(["box-sizing:border-box;word-wrap:break-word;"]);
Wrapper.displayName = 'Wrapper';
const Header = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40027066__sc-un02xd-3"
})(["background:", ";border-bottom:", ";padding-inline:", ";padding-block:", ";display:flex;align-items:center;justify-content:space-between;", ""], ({
  theme
}) => theme.surface.container.default, ({
  theme
}) => theme.border.subtle.default, ({
  theme
}) => theme.spacing.small.default, ({
  theme
}) => theme.spacing.xsmall.default, isMobile(css(["padding-inline:", ";padding-block:", ";"], ({
  theme
}) => theme.spacing.small.mobile, ({
  theme
}) => theme.spacing.xsmall.mobile)));
Header.displayName = 'Header';
const HeaderCloseButton = /*#__PURE__*/styled(CloseButton).withConfig({
  componentId: "sc-storm-ui-40027066__sc-un02xd-4"
})(["align-self:start;"]);
const Content = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40027066__sc-un02xd-5"
})(["background:", ";overflow-y:auto;max-height:calc(100vh - 13rem);", " ", ""], ({
  theme
}) => theme.surface.container.default, paddingMixin, isMobile(css(["", ""], mobilePaddingMixin)));
Content.displayName = 'Content';
const Footer = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40027066__sc-un02xd-6"
})(["background:", ";padding-inline:", ";padding-block:", ";display:flex;justify-content:flex-end;gap:", ";border-top:", ";", ""], ({
  theme
}) => theme.surface.container.default, ({
  theme
}) => theme.spacing.xsmall.default, ({
  theme
}) => theme.spacing.xsmall.default, ({
  theme
}) => theme.spacing.small.default, ({
  theme
}) => theme.border.subtle.default, isMobile(css(["padding-inline:", ";padding-block:", ";"], ({
  theme
}) => theme.spacing.xsmall.mobile, ({
  theme
}) => theme.spacing.xsmall.mobile)));
Footer.displayName = 'Footer';

export { Content as C, Footer as F, Header as H, OuterWrapper as O, Shroud as S, Wrapper as W, HeaderCloseButton as a };
//# sourceMappingURL=Modal.styles-BWOrZl5N.js.map
